import _concat from 'lodash/concat'
import _each from 'lodash/each'
import _sortBy from 'lodash/sortBy'

import { getItemType } from '../../components/blocks/resource-store/ResourceListItemModel'

export const resourceTypes = ['files', 'links', 'pages', 'waivers']

function getEmptyStore() {
  let types = []
  _each(resourceTypes, type => {
    types[type] = []
  })
  return types
}

export function mergeResourceStores(stores, mergedStoreTitle = 'Resources') {
  let types = getEmptyStore()

  let currentBaseIndex = 0
  _each(_sortBy(stores, 'order'), store => {
    _each(resourceTypes, type => {
      _each(store[type], resource => {
        let resourceToMerge = { ...resource }
        resourceToMerge.order = resource.order + currentBaseIndex
        types[type].push(resourceToMerge)
      })
    })

    currentBaseIndex += countResourcesInResourceStore(types)
  })

  let mergedStore = {
    order: 0,
    title: mergedStoreTitle
  }

  _each(resourceTypes, type => {
    mergedStore[type] = types[type]
  })

  return mergedStore
}

export function countResourcesInResourceStore(store) {
  let count = 0
  _each(resourceTypes, type => {
    count += typeof store !== 'undefined' && store[type] ? store[type].length : 0
  })
  return count
}

export function isResourceListLimited(store, limit) {
  return countResourcesInResourceStore(store) > limit
}

export function sortByFeatured(store) {
  let types = getEmptyStore()

  let currentBaseIndex = 0
  let flatStore = flattenStore(store)

  _each([true, false], featuredFilter => {
    // feature first, then non-featured in their natural order
    _each(flatStore, resource => {
      if (featuredFilter === (resource.featured || false)) {
        let resourceToMerge = { ...resource }
        resourceToMerge.order = currentBaseIndex
        let itemResourceType = getItemResourceType(resourceToMerge)

        if (itemResourceType) {
          types[itemResourceType].push(resourceToMerge)
          currentBaseIndex++
        }
      }
    })
  })

  _each(resourceTypes, type => {
    store[type] = types[type]
  })

  return store
}

export function flattenStore(store) {
  let resources = []
  _each(resourceTypes, type => {
    resources = _concat(resources, store[type] || [])
  })
  return _sortBy(resources, 'order')
}

export function getItemResourceType(item, plural = true) {
  let resourceType
  switch (getItemType(item)) {
    case 'attachment':
      resourceType = 'file'
      break
    case 'link':
      resourceType = 'link'
      break
    case 'page':
      resourceType = 'page'
      break
  }
  if (resourceType) {
    if (plural) {
      resourceType += 's'
    }
    return resourceType
  }
}

export function appendResourcesToStore(store, newResources) {
  let updatedStore = { ...store }
  let baseIndex = countResourcesInResourceStore(updatedStore)
  _each(resourceTypes, resourceType => {
    if (newResources[resourceType].length) {
      _each(newResources[resourceType], resource => {
        let newResource = { ...resource }
        newResource.order = baseIndex + newResource.order
        updatedStore[resourceType].push(newResource)
      })
    }
  })
  return updatedStore
}
